import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import "./Woroworo.scss";

const Woroworo = ({ text, kefal, popup }) => {
  return (
    <>
      <AnimatePresence>
        {popup ? (
          <motion.div
            initial={{ y: -30 }}
            animate={{ y: 10 }}
            exit={{ y: -180 }}
            className="popup-state"
          >
            <div className="popup-state-box">
              <h4>Peringatan!</h4>
              <p>{text}</p>
              <button onClick={kefal}>tutup</button>
              <img
                className="dankmeme"
                src="https://telegra.ph/file/a4919220abad795f1cc42.png"
                alt="source"
              />
            </div>
          </motion.div>
        ) : (
          ""
        )}
      </AnimatePresence>
    </>
  );
};

export default Woroworo;
